<template>
    <svg viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.9125 0.447063L10.5002 0.282715L9.08788 0.447063L0.730957 15.1116L2.14942 17.5001H10.5002H18.851L20.2694 15.1116L11.9125 0.447063ZM11.4325 6.04272L11.2786 11.1085H9.72173L9.56788 6.04272H11.4325ZM9.4848 13.5925C9.4848 14.1725 9.86557 14.5176 10.5025 14.5176C11.1348 14.5176 11.5148 14.1725 11.5148 13.5925C11.5148 13.0017 11.1348 12.6565 10.5025 12.6565C9.8648 12.6565 9.4848 13.0017 9.4848 13.5925Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
export default {
    name: "DangerIcon",
};
</script>
